import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'store'
import { ChartKey, TTrendChartResponseType } from 'types/models/DataAnalysis'

export const selectChartState = (key: ChartKey) => (state: RootState) =>
  state.dataAnalysis.byKey[key]

export const selectDraftFilters = (key: ChartKey) =>
  createSelector(selectChartState(key), (c) => c?.draft ?? null)

export const selectAppliedFilters = (key: ChartKey) =>
  createSelector(selectChartState(key), (c) => c?.applied ?? null)

export const selectChartData =
  (key: ChartKey) =>
  (state: RootState): TTrendChartResponseType[] | null =>
    state.dataAnalysis.byKey[key]?.data ?? null

export const selectChartStatus = (key: ChartKey) =>
  createSelector(selectChartState(key), (c) => c?.status ?? 'idle')

export const selectChartError = (key: ChartKey) =>
  createSelector(selectChartState(key), (c) => c?.error ?? null)

export const selectWheatColorByCodeMap = (state: RootState) =>
  state.dataAnalysis.wheatColors.byCode

export const selectWheatColorByIdMap = (state: RootState) =>
  state.dataAnalysis.wheatColors.byId

export const makeSelectColorForCode = (code: string) => (state: RootState) =>
  state.dataAnalysis.wheatColors.byCode[code]

// Global filters selectors
export const selectIsApplyGlobally = (state: RootState) =>
  state.dataAnalysis.globalFilters.isApplyGlobally

export const selectGlobalDraftFilters = (state: RootState) =>
  state.dataAnalysis.globalFilters.draft

export const selectGlobalAppliedFilters = (state: RootState) =>
  state.dataAnalysis.globalFilters.applied
